window.PlummeI18n.register('no', {
  'adv.plan.viewForecast': 'Se prognose',
  'adv.plan.forecastTitle': 'Kontantstrøm med planlagte hendelser',
  'adv.plan.forecastIntro': 'Sammenlign saldoen basert på bokførte tall med saldoen etter hendelsene du har registrert.',
  'adv.plan.forecastWithoutEvents': 'Uten planlagte hendelser',
  'adv.plan.forecastWithEvents': 'Med planlagte hendelser',
  'adv.plan.forecastChange': 'Endring ved årets slutt',
  'adv.plan.forecastScope': 'Planlagte hendelser endrer bare prognosen, ikke bokføring eller budsjett. Saldoen stopper ved null i kurven, så endringen ved årets slutt kan være mindre enn summen av hendelsene.',
  'adv.plan.showVariance': 'Vis avvik',
  'adv.plan.hideVariance': 'Skjul avvik',
});
